<script>
    import { Line } from 'vue-chartjs';

    export default {
        name: "LineChart",
        extends: Line,
        props: {
            datasetsList: {
                type: Array,
                default: () => [],
            },
            labelsList: {
                type: Array,
                default: () => [],
            },
        },
        data () {
            return {
                data: {
                    labels: [],
                    datasets: [],
                },
                options: {
                    // animation: false,
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 8,
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                fontSize: 10,
                            }
                        }],
                    },
                }
            }
        },
        methods: {
            updateChart: function () {
                this.data.labels = JSON.parse(JSON.stringify(this.labelsList));
                this.data.datasets = JSON.parse(JSON.stringify(this.datasetsList));
                this.renderChart(this.data, this.options);
            }
        },
        watch: {
            datasetsList: function () {
                this.updateChart();
            },
        },
        mounted () {
            this.updateChart();
        },
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/LineChart.vue